<!-- <lds-topbar></lds-topbar> -->
<div class="mdl-layout__container">
  <lds-ng-lw-data-studio [hidden]="!user.loading"></lds-ng-lw-data-studio>
  <div
    class="demo-layout mdl-layout mdl-js-layout mdl-layout--fixed-drawer mdl-layout--fixed-header has-drawer is-upgraded"
    [ngClass]="myClass">
    <header class="demo-header mdl-layout__header is-casting-shadow">
      <div [attr.aria-expanded]="buttonAria" role="button" class="menu-btn-container mdl-layout__drawer-button"
        tabindex="0" (click)=buttonClicked()>
        <i class="material-icons">menu</i>
      </div>
      <div class="lw-gradient-text mdl-layout__header-row">
        <span class="mdl-layout-title">{{user.currentModule}}</span>
        <div class="mdl-layout-spacer"></div>
        <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable">
          <!-- <label class="mdl-button mdl-js-button mdl-button--icon" for="search">
          <i class="material-icons">search</i>
        </label> -->
        <div class="mdl-textfield__expandable-holder">
          <input class="mdl-textfield__input" type="text" id="search">
          <label class="mdl-textfield__label" for="search">Enter your query...</label>
        </div>
      </div>

      <button (click)="logout()" class="logout-btn-container" routerLink="/">
        <p class="logout-text sign-out">Sign out</p>
        <i class="logout-icon material-icons">exit_to_app</i>
      </button>
      <ul class="mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right is-visible" for="hdrbtn">
        <li class="mdl-menu__item">About</li>
        <li class="mdl-menu__item">Contact</li>
        <li class="mdl-menu__item">Legal information</li>
      </ul>
    </div>
  </header>
  <div [ngClass]="drawerClass" class="demo-drawer mdl-layout__drawer" [attr.aria-hidden]="drawerAria">
    <header class="demo-drawer-header lw-grey-bg">
      <img src="/assets/icons/lightwave-text-white.png" class="demo-avatar" alt="Lightwave Text Logo">
      <div class="demo-avatar-dropdown">
        <span>{{user.userDetail.user.email}}</span>
      </div>
    </header>
    <nav class="demo-navigation mdl-navigation lw-light-grey-bg">
      <a class="mdl-navigation__link" (click)="navClicked()" routerLink="/data-studio/energy/overview"
        routerLinkActive="active"><i class="material-icons" role="presentation">home</i>Home</a>
        <a class="mdl-navigation__link" (click)="navClicked()" routerLink="/data-studio/devices"
          routerLinkActive="active"><i class="material-icons" role="presentation">view_list</i>Devices</a>
          @if (!isDemo) {
            <a class="mdl-navigation__link" (click)="navClicked('home')" routerLink="/data-studio/home"
              routerLinkActive="active"><i class="material-icons" role="presentation">settings</i>Settings</a>
            }
            @if (!isDemo) {
              <a class="mdl-navigation__link" (click)="navClicked()" routerLink="/data-studio/feedback"
                routerLinkActive="active"><i class="material-icons" role="presentation">campaign</i>Feedback</a>
              }
              <a class="mdl-navigation__link" (click)="navClicked()" routerLink="/data-studio/about"
                routerLinkActive="active"><i class="material-icons" role="presentation">contact_support</i>About</a>
                <a class="mdl-navigation__link" (click)="navClicked()" routerLink="/data-studio/battery" routerLinkActive="active">
                  <i class="material-icons"
                  role="presentation">battery_5_bar</i>
                  Battery Devices
                </a>
                @if (energyMonitor || octopusUser) {
                  <div>
                    <a class="mdl-navigation__link" (click)="navClicked('energy-monitor')"
                      routerLink="/data-studio/energy-monitors" routerLinkActive="active"><i class="material-icons"
                    role="presentation">electric_meter</i>Energy Monitor</a>
                  </div>
                }
                <div class="mdl-layout-spacer"></div>
                <div class="beta-container">
                  <img src="/assets/icons/lw_beta.png" alt="LightwaveBeta" class="beta-logo">
                </div>
              </nav>
            </div>
            <main class="mdl-layout__content">
              <router-outlet></router-outlet>
            </main>
            <div [ngClass]="overlayClass" class="mdl-layout__obfuscator" (click)="overlayClicked()"></div>
          </div>


        </div>
